import * as React from 'react';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import useTheme from '@mui/material/styles/useTheme';
import Logo from './Logo';
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const pages = ['About','Demo', 'Docs'];
  const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const theme = useTheme();

  //return <Container maxWidth="md">header</Container>;
  return (
    <AppBar position="static" color="transparent" sx={{boxShadow:'none'}}>
      <Container maxWidth="md">
        <Toolbar disableGutters>
        <Box sx={{display: { xs: 'none', md: 'flex' } }}>
            <Link to="/"><Logo color={theme?.palette.logo||''}/></Link>
            </Box>
          

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
                <MenuItem sx={{minWidth:'200px', py:3}} onClick={()=>{navigate('/about');handleCloseNavMenu();}}>
                  <Typography sx={{ml:3}} textAlign="center">About</Typography>
                </MenuItem>
                <MenuItem sx={{minWidth:'200px', py:3}} onClick={()=>{navigate('/demo');handleCloseNavMenu();}}>
                  <Typography sx={{ml:3}} textAlign="center">Demo</Typography>
                </MenuItem>
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          <Link to="/"><Logo color={theme?.palette.logo||''}/></Link>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

          <Button onClick={()=>navigate('/about')} sx={{ my: 2, color: 'primary', display: 'block', marginLeft:'auto'}}>About</Button>
          <Button onClick={()=>navigate('/demo')} sx={{ my: 2, color: 'primary', display: 'block', mr:'auto'}}>Demo</Button>
          {/* <a href="https://localhost:8443/docs/" style={{textDecoration:'none',marginRight:'auto'}}><Button sx={{ my: 2, color: 'primary', display: 'block'}}>Docs</Button></a> */}
              
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Button onClick={()=>navigate('/contact')} variant="contained">Contact</Button>
            {/* <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip> */}
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}